<template>
  <div>
    <d-form>
      <d-form-row class="form-group">
        <d-col cols="12" md="9">
          <label>Título:</label>
          <d-form-input type="text" v-model="model.name" :state="hasErrorFiled('name')"/>
          <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
        </d-col>
        <d-col cols="12" md="3" class="text-right d-flex align-items-end justify-content-end">
          <label>Jogo Grátis?</label>
          <d-checkbox toggle @change="toggleGameFree()" :checked="model.cat_id === 1" class="ml-3 custom-toggle-sm">
            <span v-if="model.cat_id === 1">Sim</span>
            <span v-else>Não</span>
          </d-checkbox>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group">
        <d-col cols="6">
          <label>Tipo de jogo:</label>
          <d-select v-model="model.type_id" :state="hasErrorFiled('type_id')" :disabled="!!model.id" @change="changedType">
            <option :value="option.id" v-for="option in types" :key="option.id">{{ option.name }}</option>
          </d-select>
          <d-form-invalid-feedback>Tipo é obrigatório</d-form-invalid-feedback>
        </d-col>
        <d-col cols="6">
          <label>Dificuldade:</label>
          <d-select v-model="model.level_id" :state="hasErrorFiled('level_id')" @change="chooseLevel">
            <option :value="option.id" v-for="option in levels" :key="option.id">{{ option.name }}</option>
          </d-select>
          <d-form-invalid-feedback>Dificuldade é obrigatório</d-form-invalid-feedback>
        </d-col>
      </d-form-row>
      <d-form-row class="form-group">
        <d-col cols="12">
          <label>Imagem destacada:</label>
          <upload-image :model.sync="model" />
        </d-col>
      </d-form-row>
      <component
        :is="puzzleType"
        :key="model.type_id"
        :model.sync="model"
        v-if="showPuzzle && puzzleType"
      />
      <d-alert v-else-if="showPuzzle && selectedType" theme="warning" :show="true" class="mb-0">
        Tipo de jogo não suportado
        <span v-if="selectedType.slug">({{ selectedType.slug }})</span>.
      </d-alert>
    </d-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep, stringfy, getDateTimeUTCISO } from '_utils';
import mixin from '_common/mixins/ValidateForm';
import UploadImage from '_shared/UploadImage.vue';
import PuzzleService from '_services/rest/modules/puzzle';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import Numerex from './PuzzlesTypes/Numerex.vue';
import Letrex from './PuzzlesTypes/Letrex.vue';
import CrossWords from './PuzzlesTypes/CrossWords/index.vue';
import HuntingWords from './PuzzlesTypes/HuntingWords.vue';
import Cryptogram from './PuzzlesTypes/Cryptogram/index.vue';
import {
  MODEL,
  TYPE_DEFAULT,
  _LOAD_MODEL_,
  _PUZZLE_CHOOSE_LEVEL_,
} from './PuzzleModel';

export default {
  name: 'puzzle-form',
  mixins: [mixin],
  components: {
    Letrex,
    Numerex,
    CrossWords,
    UploadImage,
    HuntingWords,
    Cryptogram,
    ConfirmationModal,
  },
  computed: {
    types() {
      const { types } = this.$store.state.puzzle;
      if (types.length) {
        return types;
      }
      return [];
    },
    levels() {
      const { levels } = this.$store.state.puzzle;
      if (levels.length) {
        return levels;
      }
      return [];
    },
    status() {
      const { status } = this.$store.state.puzzle;
      if (status.length) {
        return status;
      }
      return [];
    },
    selectedType() {
      return this.types.find(t => Number(t.id) === Number(this.model.type_id)) || this.type;
    },
    puzzleType() {
      const puzzleTypes = {
        'caca-palavras': 'HuntingWords',
        'palavra-cruzadas': 'CrossWords',
        numerex: 'Numerex',
        letrex: 'Letrex',
        'palavra-criptograma': 'Cryptogram',
      };

      if (!this.selectedType || !this.selectedType.slug) {
        return null;
      }
      return puzzleTypes[this.selectedType.slug] || null;
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      title: 'Confirmação',
      callback: null,
      message: 'Tem certeza que deseja continuar?',
      showPuzzle: false,
      type: cloneDeep(TYPE_DEFAULT),
      errors: {
        name: { required: false },
        type_id: { required: false },
        level_id: { required: false },
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getTypesList',
      'getLevelsList',
      'getStatusList',
    ]),
    chooseLevel(param) {
      if (!this.selectedType || this.selectedType.slug !== 'caca-palavras') {
        return;
      }
      Events.$emit(_PUZZLE_CHOOSE_LEVEL_, param);
    },
    getOptions() {
      if (this.types.length === 0) {
        this.getTypesList();
      }
      if (this.levels.length === 0) {
        this.getLevelsList();
      }
      if (this.status.length === 0) {
        this.getStatusList();
      }
    },
    draft() {
      this.model.status_id = 1;
      this.save('Jogo salvo como rascunho com sucesso');
    },
    publish() {
      this.model.status_id = 2;
      this.model.published_date = new Date();
      this.save('Jogo publicado com sucesso');
    },
    save(message = 'Jogo salvo com sucesso') {
      if (this.checkForm()) {
        this.model.slug = stringfy(this.model.name);
        this.model.type_id = this.selectedType.id;
        this.model.published_date = getDateTimeUTCISO(this.model.published_date);
        PuzzleService.save(this.model)
          .then(response => {
            this.activeAlert({ message, theme: 'success' });
            this.$router.push({
              name: 'admin-puzzle-edit',
              params: { puzzleId: response.data.id },
            });
          })
          .catch(error => {
            this.activeAlert({ message: error.message, theme: 'danger' });
          });
      }
    },
    toggleGameFree() {
      let catId = 1;
      if (this.model.cat_id === 1) {
        catId = null;
      }
      this.model.cat_id = catId;
    },
    changedType(typeId) {
      if (this.type && Number(this.type.id) === Number(typeId)) {
        return;
      }
      const selected = this.types.find(t => Number(t.id) === Number(typeId));
      if (!selected) {
        return;
      }
      this.type = selected;
      this.model.data = cloneDeep(MODEL).data;
    },
  },
  mounted() {
    this.getOptions();
    this._onLoadModel = model => {
      this.model = model;
      this.type = model.type;
      this.showPuzzle = true;
      this.setToggle({ type: 'progress', bool: false });
    };
    Events.$on(_LOAD_MODEL_, this._onLoadModel);
  },
  beforeDestroy() {
    Events.$off(_LOAD_MODEL_, this._onLoadModel);
  },
};
</script>

